import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './utils/ThemeContext';
import Layout from './components/layout/Layout';
import Onboarding from './pages/Onboarding';
import Login from './pages/Login';
import JobFeed from './pages/JobFeed';
import JobDetail from './pages/JobDetail';
import SavedJobs from './pages/SavedJobs';
import ApplicationFlow from './pages/ApplicationFlow';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
export function App() {
  const [hasSeenOnboarding, setHasSeenOnboarding] = useState(false);
  // Check if user has seen onboarding
  useEffect(() => {
    const onboardingSeen = localStorage.getItem('onboardingSeen');
    if (onboardingSeen) {
      setHasSeenOnboarding(true);
    }
  }, []);
  const completeOnboarding = () => {
    localStorage.setItem('onboardingSeen', 'true');
    setHasSeenOnboarding(true);
  };
  return <ThemeProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={hasSeenOnboarding ? <Navigate to="/login" data-id="element-4" /> : <Onboarding onComplete={completeOnboarding} data-id="element-5" />} data-id="element-3" />
          <Route path="/login" element={<Login data-id="element-7" />} data-id="element-6" />
          <Route path="/" element={<Layout data-id="element-9" />} data-id="element-8">
            <Route path="/jobs" element={<JobFeed data-id="element-11" />} data-id="element-10" />
            <Route path="/jobs/:id" element={<JobDetail data-id="element-13" />} data-id="element-12" />
            <Route path="/saved" element={<SavedJobs data-id="element-15" />} data-id="element-14" />
            <Route path="/apply/:id" element={<ApplicationFlow data-id="element-17" />} data-id="element-16" />
            <Route path="/profile" element={<Profile data-id="element-19" />} data-id="element-18" />
            <Route path="/notifications" element={<Notifications data-id="element-21" />} data-id="element-20" />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>;
}